export const colors = {
  lightGrey: "#eaebea",
  darkGreen: "#143622",
  darkGrey: "#747474",
  stone: "#8d9491",
  smoke: "#babfbd",
  navyGreen: "#747e74",
  lightGreen: "#6c947c",
};
